import React, { useEffect, useState } from "react";
import Modal from "../../../shared/modal/Modal";
import { apiUrl } from "../../../environment/environment";
import NoRecordsRow from "../../../shared/UI/no-records-table-row";
import _axiosInstance from "../../../shared/services/axios.instance";
import showAlert from "../../../shared/services/alert.service";

import { useFormik } from "formik";
import * as Yup from "yup";
import {
  formatNumberToTwoDecimals,
  scrollToTop,
} from "../../../shared/services/helper";

const Accounts = () => {
  useEffect(() => {
    const getData = async () => {
      try {
        const result = await _axiosInstance.get("accounts");
        if (result.data.status === "ok") {
          setData(result.data.data);
          setTotalOwed(result.data.totalOwed);
          setTotalPaid(result.data.totalPaid);
          setTotalReceivable(result.data.totalReceivable);
          setTotalReceived(result.data.totalReceived);
        }
      } catch (error) {
        console.log("Error", error);
      }
    };

    getData();
  }, []);
  const [showModal, setModal] = useState(false);
  let currentProject = {};
  const formik = useFormik({
    initialValues: {
      id: "",
      description: "",
      amount: "",
      transaction_type: "",
      due_date: "",
      status: "",
      priority: "",
      category: "",
      contact_information: "",
      notes: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      id: Yup.string(),
      description: Yup.string().required("Description is required"),
      amount: Yup.string().required("amount is required"),
      transaction_type: Yup.string().required("transaction_type is required"),
      due_date: Yup.string().required("Due date is required"),
      status: Yup.string().required("status is required"),
      priority: Yup.string().required("priority is required"),
      category: Yup.string().required("Category is required"),
      contact_information: Yup.string().required("Contact is required"),
    }),
    onSubmit: async (values) => {
      try {
        const res = await _axiosInstance.post(
          `accounts/${values.id ? "update" : "add"}`,
          values
        );
        if (res.data.status === "ok") {
          showAlert("success", res.data.message);
        } else {
          showAlert("error", res.data.message);
        }
        setModal(false);
        getAccountData();
      } catch (error) {
        console.error("error", error);
        let msg = error.response.data.message ?? "Something went wrong.";
        showAlert("error", msg);
      }
    },
  });

  const onCloseHandler = () => {
    setModal(false);
    scrollToTop();
  };
  const onDeleteHandler = async (value) => {
    if (window.confirm("Are you sure you want to delete " + value.name + "?")) {
      const res = await _axiosInstance.delete("accounts/delete?id=" + value.id);
      if (res.data.status === "ok") {
        showAlert("success", res.data.message);
        getAccountData();
      } else {
        showAlert("error", res.data.message);
      }
    }
  };
  const onAddHandler = () => {
    setModal(true);
    currentProject = {};
    formik.resetForm();
  };

  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [totalOwed, setTotalOwed] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalReceivable, setTotalReceivable] = useState(0);
  const [totalReceived, setTotalReceived] = useState(0);

  const [data, setData] = useState([]);

  const getAccountData = async () => {
    setModal(false);
    _axiosInstance.get(`${apiUrl}accounts`).then((res) => {
      if (res.data.status === "ok") {
        setData(res.data.data);
        setTotalOwed(res.data.totalOwed);
        setTotalPaid(res.data.totalPaid);
        setTotalReceivable(res.data.totalReceivable);
        setTotalReceived(res.data.totalReceived);
      } else {
        setData([]);
        setTotalOwed(res.data.totalOwed);
        setTotalPaid(res.data.totalPaid);
        setTotalReceivable(res.data.totalReceivable);
        setTotalReceived(res.data.totalReceived);
      }
    });
  };
  const onEditHandler = (value) => {
    currentProject = value;
    mode = "edit";
    formik.setValues({
      ...value,
      id: value.id,
      due_date: formatDateForInput(value.due_date),
    });
    setModal(true);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };
  let mode = "";

  return (
    <React.Fragment>
      <div className="container">
        <div className="title">
          <h2>Accounts</h2>
        </div>

        <div className="button_wrap mt-3 mb-3">
          <button className="btn btn-primary" onClick={onAddHandler}>
            Add
          </button>
        </div>
        {/* form starts here  */}
        {showModal && (
          <Modal>
            <div className="modal-header bg-primary text-white">
              <h2>{mode === "edit" ? "Edit" : "Add"} Account</h2>
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="title">
                    Description <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    alt="fss"
                    id="description"
                    name="description"
                    placeholder="Description"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description}
                    className={`form-control ${
                      formik.errors.description && "invalid"
                    }`}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <span className="text-danger small">
                      {formik.errors.description}
                    </span>
                  )}
                </div>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="amount">
                        Amount<span className="text-danger">*</span>{" "}
                      </label>
                      <input
                        type="text"
                        alt="fss"
                        id="amount"
                        name="amount"
                        placeholder="10.55"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.amount}
                        className={`form-control ${
                          formik.errors.amount && "invalid"
                        }`}
                      />
                      {formik.touched.amount && formik.errors.amount && (
                        <span className="text-danger small">
                          {formik.errors.amount}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="title">
                        Transaction Type <span className="text-danger">*</span>{" "}
                      </label>

                      <select
                        title="select"
                        name="transaction_type"
                        id="transaction_type"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.transaction_type}
                        className={`form-control ${
                          formik.errors.transaction_type && "invalid"
                        }`}
                      >
                        <option value="">Select Type</option>
                        <option value="Owe">Owe</option>
                        <option value="Receive">Receive</option>
                      </select>

                      {formik.touched.transaction_type &&
                        formik.errors.transaction_type && (
                          <span className="text-danger small">
                            {formik.errors.transaction_type}
                          </span>
                        )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="title">
                        Due Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        alt="fss"
                        id="due_date"
                        name="due_date"
                        placeholder="20/09/2016"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.due_date}
                        className={`form-control ${
                          formik.errors.due_date && "invalid"
                        }`}
                      />
                      {formik.touched.due_date && formik.errors.due_date && (
                        <span className="text-danger small">
                          {formik.errors.due_date}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="title">
                        Priority <span className="text-danger">*</span>{" "}
                      </label>

                      <select
                        title="select"
                        name="priority"
                        id="priority"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`form-control ${
                          formik.errors.priority && "invalid"
                        }`}
                        value={formik.values.priority}
                      >
                        <option value="">Select priority</option>
                        <option value="High">High</option>
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                      </select>

                      {formik.touched.priority && formik.errors.priority && (
                        <span className="text-danger small">
                          {formik.errors.priority}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="title">
                        Contact Info<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        alt="fss"
                        id="contact_information"
                        name="contact_information"
                        placeholder="John Doe"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.contact_information}
                        className={`form-control ${
                          formik.errors.contact_information && "invalid"
                        }`}
                      />
                      {formik.touched.contact_information &&
                        formik.errors.contact_information && (
                          <span className="text-danger small">
                            {formik.errors.contact_information}
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="title">
                        Category <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        alt="fss"
                        id="category"
                        name="category"
                        placeholder="Description"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.category}
                        className={`form-control ${
                          formik.errors.category && "invalid"
                        }`}
                      />
                      {formik.touched.category && formik.errors.category && (
                        <span className="text-danger small">
                          {formik.errors.category}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="title">
                        Status <span className="text-danger">*</span>{" "}
                      </label>

                      <select
                        title="selectPaid"
                        name="status"
                        id="status"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status}
                        className={`form-control ${
                          formik.errors.status && "invalid"
                        }`}
                      >
                        <option value="">Select status</option>
                        <option value="Paid" label="Paid">
                          Paid
                        </option>
                        <option value="Overdue" label="Overdue">
                          Overdue
                        </option>
                        <option value="Pending" label="Pending">
                          Pending
                        </option>
                      </select>

                      {formik.touched.status && formik.errors.status && (
                        <span className="text-danger small">
                          {formik.errors.status}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label htmlFor="title">Notes</label>
                      <input
                        type="text"
                        alt="fss"
                        id="notes"
                        name="notes"
                        placeholder="Notes"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.notes}
                        className={`form-control ${
                          formik.errors.notes && "invalid"
                        }`}
                      />
                      {formik.touched.notes && formik.errors.notes && (
                        <span className="text-danger small">
                          {formik.errors.notes}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={onCloseHandler}>
                  Close
                </button>
                <button className="btn btn-success" type="submit">
                  Save
                </button>
              </div>
            </form>
          </Modal>
        )}
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Description</th>
                <th scope="col">Amount</th>
                <th scope="col">Due Date</th>
                <th scope="col">Contact</th>
                <th scope="col">Type</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((data) => {
                  return (
                    <tr
                      key={data.id}
                      className={data.status === "Paid" ? "green-bg" : "red-bg"}
                    >
                      <td>{data.description}</td>
                      <td>{data.amount}</td>
                      <td>{formatDate(data.due_date)}</td>
                      <td>{data.contact_information}</td>
                      <td>{data.transaction_type}</td>
                      <td>
                        <div
                          className="d-flex"
                          style={{
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => {
                              onEditHandler(data);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger btn-sm ml-2"
                            onClick={() => {
                              onDeleteHandler(data);
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <NoRecordsRow colSpan="5" align="center"></NoRecordsRow>
              )}
            </tbody>
          </table>
        </div>

        <TotalContainer
          totalOwed={totalOwed}
          totalPaid={totalPaid}
          totalReceivable={totalReceivable}
          totalReceived={totalReceived}
        />
      </div>
    </React.Fragment>
  );
};
const TotalContainer = ({
  totalOwed,
  totalPaid,
  totalReceivable,
  totalReceived,
}) => {
  return (
    <div
      style={{
        marginTop: "auto",
        borderTop: "1px solid #ccc",
        paddingTop: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <div style={{ marginRight: "20px" }}>
          Total Owed:
          <span
            style={{
              fontWeight: "600",
            }}
          >
            AUD {formatNumberToTwoDecimals(totalOwed) ?? "0.00"}
          </span>
        </div>
        <div style={{ marginRight: "20px" }}>
          Total Paid:{" "}
          <span
            style={{
              fontWeight: "600",
            }}
          >
            AUD {formatNumberToTwoDecimals(totalPaid) ?? "0.00"}
          </span>
        </div>
        <div style={{ marginRight: "20px" }}>
          Total Receivable:{" "}
          <span
            style={{
              fontWeight: "600",
            }}
          >
            AUD {formatNumberToTwoDecimals(totalReceivable) ?? "0.00"}
          </span>
        </div>
        <div>
          Total Received:
          <span
            style={{
              fontWeight: "600",
            }}
          >
            AUD {formatNumberToTwoDecimals(totalReceived) ?? "0.00"}
          </span>
        </div>
      </div>
      <div />
    </div>
  );
};
export { Accounts };
